export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left Image */}
          <div className="lg:w-[35%] flex-shrink-0">
            <div className="relative">
              <span className="inline-block px-3 py-1 rounded-full border border-accent-400 text-xs font-medium text-accent-600 mb-4 whitespace-nowrap">
                Data-Driven
              </span>
              <div className="w-full h-[280px] md:h-[340px] rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Organized%20product%20research%20workspace%20with%20multiple%20product%20samples%20shoes%20accessories%20and%20bags%20displayed%20on%20wooden%20desk%20alongside%20laptop%20showing%20colorful%20data%20charts%2C%20warm%20natural%20window%20lighting%2C%20minimalist%20creative%20aesthetic%20with%20soft%20cream%20and%20beige%20tones%2C%20professional%20yet%20inviting%20atmosphere%2C%20editorial%20product%20photography%20with%20shallow%20depth%20of%20field%20and%20gentle%20shadows&width=800&height=680&seq=about-product-scene-v2&orientation=portrait"
                  alt="Product research with OOPBuy spreadsheet on laptop"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="lg:flex-1">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 leading-tight mb-4">
              Understand the Power of OOPBuy Spreadsheet
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-xl">
              The <strong>OOPBuy Spreadsheet</strong> is a structured product research system that organizes product data into clear, searchable tables. It is widely used by e-commerce sellers to evaluate product potential before sourcing.
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-8 max-w-xl">
              Instead of guessing what to sell, you can analyze product demand, competition level, profit margin, and market trends &mdash; all from a single organized spreadsheet system.
            </p>

            {/* Quote */}
            <blockquote className="border-l-[3px] border-accent-400 pl-4 py-1 mb-8">
              <p className="text-base md:text-lg font-heading italic text-foreground-800">
                Make data-driven decisions instead of relying on guesswork.
              </p>
            </blockquote>

            {/* Comparison Table */}
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="border-b border-background-300">
                    <th className="text-left py-3 pr-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Method</th>
                    <th className="text-left py-3 px-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Speed</th>
                    <th className="text-left py-3 px-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Accuracy</th>
                    <th className="text-left py-3 px-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Profit Insight</th>
                    <th className="text-left py-3 pl-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Risk Level</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-200/70">
                    <td className="py-3 pr-4 text-foreground-700">Manual Research</td>
                    <td className="py-3 px-4 text-foreground-500">Slow</td>
                    <td className="py-3 px-4 text-foreground-500">Medium</td>
                    <td className="py-3 px-4 text-foreground-500">Low</td>
                    <td className="py-3 pl-4 text-primary-500 font-medium">High</td>
                  </tr>
                  <tr className="border-b border-background-200/70">
                    <td className="py-3 pr-4 text-foreground-700">Agent-Based Sourcing</td>
                    <td className="py-3 px-4 text-foreground-500">Medium</td>
                    <td className="py-3 px-4 text-foreground-500">Medium</td>
                    <td className="py-3 px-4 text-foreground-500">Medium</td>
                    <td className="py-3 pl-4 text-secondary-600 font-medium">Medium</td>
                  </tr>
                  <tr>
                    <td className="py-3 pr-4 text-accent-600 font-medium">OOPBuy Spreadsheet</td>
                    <td className="py-3 px-4 text-accent-600 font-medium">Fast</td>
                    <td className="py-3 px-4 text-accent-600 font-medium">High</td>
                    <td className="py-3 px-4 text-accent-600 font-medium">High</td>
                    <td className="py-3 pl-4 text-accent-600 font-medium">Low</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-block mt-8 px-8 py-3 rounded-full bg-foreground-800 text-white text-sm font-medium hover:bg-foreground-900 transition-all whitespace-nowrap cursor-pointer"
            >
              View Full Database <i className="ri-arrow-right-up-line ml-1 align-middle"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}